<template>
  <div class="articles">
    <h2 class="title">{{ category.name }} in {{ location.zipCity }}</h2>
    <h3>{{ subCategories.length }} Artikel</h3>
    <div class="row subcategory-row">
      <div 
        v-for="(sub, sub_key) in subCategories" 
        :id="`subcategory-${sub_key}`" 
        :key="sub_key"
        :class="sub.visible ? 'selected' : ''"
        class="col-12 col-md-6 col-lg-4 subcategory-item"
      >
        <div 
          :style="{ 'background-image': `url(${sub.jobs_tasks_categories_thumbnail_url})` }"
          class="subcategory-image d-none d-md-block" 
        />
        <img 
          :src="sub.jobs_tasks_categories_thumbnail_url" 
          width="100%" 
          alt="" 
          class="d-md-none"
        >
        <h3 class="subcategory-title">
          {{ sub.jobs_tasks_categories_name }}
        </h3>
        <template v-if="sub.description">
          <p class="subcategory-desc" v-if="!sub.readmore">
            {{ sub.description.slice(0, 100) }}
            <a 
              href="#" 
              class="" 
              @click.prevent="readmore(sub_key)"
            >... mehr lesen</a>
          </p>
          <p class="subcategory-desc" v-if="sub.readmore">
            {{ sub.description }}
          </p>
        </template>
        <div :class="sub.hide_category_description && sub.show_amount ? 'col-xs-7 pb-0' : 'col-xs-12 pb-0'">
          <div class="dropdown">
            <div 
              class="dropdown-current-article d-flex align-items-center justify-content-start" 
              :class="sub.visible ? 'active' : ''" 
              @click="toggleDropdownList($event, sub_key)">
              <button 
                v-if="sub.current_article"
                class="btn btn-default btn-sm" 
                @click="chooseArticle(sub_key, false)" 
              >
                <font-awesome-icon icon="fa-solid fa-xmark" />
              </button>
              <div 
                class="d-flex justify-content-between align-items-center ms-1" 
                style="width: 100%"
              >
                {{ sub.current_article ? sub.current_article.articles_name_short : 'Bitte wählen' }}
                <font-awesome-icon icon="fa-solid fa-caret-down" />
              </div>
            </div>
            <transition 
              name="fade" 
              mode="out-in"
            >
              <ul 
                v-show="sub.visible"
                class="dropdown-content" 
              >
                <template
                  v-for="(article, a) in sub.articles" 
                >
                  <li 
                    v-if="article.articles_name_short"
                    :key="a"
                    class="dropdown-item d-flex justify-content-between"
                    @click="chooseArticle(sub_key, article.articles_hash)"
                  >
                    <span class="dropdown-item__name">
                      {{ article.articles_name_short }}
                    </span>
                    <span class="dropdown-item__price text-right">
                      {{ article.articles_selling_price | number_format }}
                    </span>
                  </li>
                </template>
              </ul>
            </transition>
            <div 
              v-if="sub.current_article"
              class="current-article-price" 
            >
              <span 
                class="current-article-price__price"
              >
                {{ sub.current_article.articles_selling_price | number_format}}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-4 subcategory-item subcategory-item--text-only d-flex">
        <div class="bg-light subcategory-inner d-flex flex-column justify-content-between">
          <div>
            <h3 class="subcategory-title mt-0">
              Individuelle Anfrage
            </h3>
            <p>Für individuelle Anfragen kontaktiere unser Beratungsteam.</p>
          </div>
          <div class="button-group d-flex flex-md-column">
            <Button 
              :class-name="current_articles.length == 0 ? 'd-block d-md-none' : 'd-block d-md-none outline dark'"
              @obClick="goToPhone" 
            >
              <font-awesome-icon icon="fa-solid fa-phone" />
            </Button>
            <Button 
              :class-name="current_articles.length == 0 ? 'd-block d-md-none' : 'd-block d-md-none outline dark'"
              @obClick="goToContact" 
            >
              <font-awesome-icon icon="fa-solid fa-envelope" />
            </Button>
            <Button 
              :class-name="current_articles.length == 0 ? 'align-items-center justify-content-center px-1 d-none d-md-flex' : 'd-none d-md-flex outline dark align-items-center justify-content-center px-1'"
              @obClick="goToPhone"  
            >
              <font-awesome-icon 
                icon="fa-solid fa-phone" 
                class="me-2"
              /> <span>+49 (0) 221 222 0 221 0</span>
            </Button>
            <Button 
              :class-name="current_articles.length == 0 ? 'align-items-center justify-content-center px-1 d-none d-md-flex' : 'd-none d-md-flex outline dark align-items-center justify-content-center px-1'"
              @obClick="goToContact" 
            >
              <font-awesome-icon 
                icon="fa-solid fa-envelope"
                class="me-2"
              /><span>Kontaktformular</span>
            </Button>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-4 subcategory-item subcategory-item--text-only d-flex">
        <div class="bg-light subcategory-inner d-flex flex-column justify-content-between w-100">
          <div>
            <h3 class="subcategory-title mt-0">
              Bereits registriert?
            </h3>
            <p>Dann nutze unseren kostenfreien Login.</p>
          </div>
          <div class="button-group d-flex flex-md-column">
            <Button 
              class="align-items-center justify-content-center px-1 d-none d-md-flex"
              @obClick="goToLogin" 
            >
              <span>Login</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
    <div 
      class="footer footer--articles" 
      :class="footerExpanded ? 'active' : ''"
    >
      <div class="product-list mb-3">
        <h3>Deine Auswahl</h3>
        <div class="footer__articles">
          <div 
            v-for="(article, a) in current_articles" 
            :key="a"
            class="d-flex align-items-center justify-content-between footer__article" 
          >
            <span class="">{{ article.articles_name_short }}</span>
            <span class="price">{{ article.articles_selling_price | number_format }}</span>
          </div>
          <div 
            v-if="totalTravelCost" 
            class="align-items-center justify-content-between footer__total" 
          >
            <small class="">inkl. Fahrtkosten</small>
            <small class="price">{{ totalTravelCost | number_format }}</small>
          </div>
      
          <template v-for="(vat, v) in totals.vat">
            <div 
              v-if="vat.sum > 0" 
              :key="v"
              class="d-flex align-items-center justify-content-between footer__total" 
            >
              <span>MwSt {{ v }}%</span> <span>{{ vat.sum | number_format }}</span>
            </div>
          </template>
        </div>
        <div class="align-items-center justify-content-between footer__total">
          <span class="">Gesamtbetrag</span>
          <span class="price">{{ totals.brutto | number_format }}</span>
        </div>
      </div>
      <Button 
        v-if="current_articles.length > 0"
        @obClick="gotoAdressView" 
      >
        Weiter
      </Button>
      <p class="mt-3"><strong>Tipp:</strong> Bitte wähle bei Schritt 5 Angebot oder kostenpflichtig bestellen.</p>
      <div class="expand-toggle">
        <a 
          href="#" 
          @click.prevent="toogleFooterHide"
        >
          <font-awesome-icon icon="fa-solid fa-chevron-down" />
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import {
      mapActions,
        mapGetters,
    } from 'vuex'
    import Button from '../components/ux/Button.vue';
    import router from '../router';
    export default {
    name: "Articles",
    components: { Button },
    computed: {
        ...mapGetters("orders", [
          "fetching",
          "fetchingErrorCode",
          "fetchingError",
          "category", "location", "articles", "subCategories", "current_articles", "totals", "totalTravelCost", "footerExpanded"])
    },
    mounted() {
      if (this.current_articles.length == 0) {
        this.fetchCategory();
      } else {
        this.$store.commit('orders/resetFetching');
      }
    },
    methods: {
        ...mapActions("orders", ["fetchCategory"]),
        chooseArticle(sub_category_key, article_hash) {
          this.$store.dispatch('orders/addArticle', {
            sub_category_key: sub_category_key,
            articles_hash: article_hash
          });
          this.toggleDropdownList(null, sub_category_key);
        },
        toggleDropdownList(e, sub_category_key) {
          const target = e ? e.target : null;
          if (target) {
            const dropdown = e.target.closest('.dropdown');
            const new_top = dropdown.offsetTop - 200;
            if (new_top > 0 ) {
              this.$options.methods.scrollTo({ top: new_top  });
            }
          }
          this.$store.dispatch('orders/toggleArticlesVisibilty', { sub_category_key: sub_category_key });
          // this.data[subKey].visible = !this.data[subKey].visible
        },
        toogleFooterHide() {
          this.$store.commit('orders/toggleFooterHiddenState');
        },
        gotoAdressView() {
          this.$options.methods.scrollTop();
          router.push('Address');
          this.$store.dispatch("orders/navigate", 3);
        },
        goToPhone() {
          const link = document.createElement('a');
          link.href = 'tel:004922122202210';
          link.click();
          link.remove();
        },
        goToContact() {
          const link = document.createElement('a');
          link.href = 'https://offenblende.de/beratung/';
          link.click();
          link.remove();
        },
        goToLogin() {
          const link = document.createElement('a');
          link.href = 'https://www.offenblende.de/login';
          link.click();
          link.remove();
        },
        readmore(sub_category_key) {
          this.$store.dispatch('orders/subcategoryReadmore', { sub_category_key: sub_category_key });
        }
    },
}
</script>

<style lang="scss" scoped>
.current-article-price {
  background-color: $gray-light;
  padding: 15px 10px 11px 10px;
  margin-top: 10px;

  &__price {
    font-weight: 900;
  }

  &__meta {
    font-weight: 300;
    font-size: 14px;
    margin-left: 4px;
  }
}

.dropdown-content {
  padding: 0;
  margin: 0;
  // display: none;
  border: 1px solid $dark-gray;
  max-height: 30vh;
  overflow: auto;
  background-color: white;
  z-index: 12;
  .active+& {
    border-color: $primary-color;
  }

  @media (min-width: 768px) {
    position: absolute;
    left: 0;
    right: 0;
    box-shadow: 0px 20px 20px 11px rgba(0, 0, 0, 0.19);
  }
}

.dropdown-item {
  padding: 16px 10px;
  border-bottom: 1px solid $border-color;

  &__name {
    font-weight: 500;
  }
}

.dropdown-current-article {
  padding: 13px 20px 13px 13px;
  border: 1px solid $border-color;
  z-index: 10;

  &.active {
    border-color: $primary-color;
  }
}
.subcategory-row {
  margin-bottom: 50px;
  row-gap: 30px;
}
.subcategory-image {
  background-repeat: no-repeat;
  height: 200px;
  background-size: cover;
  background-position: center;

  & + img {
    min-height: 200px;
  }
}

.subcategory-item {

  &--text-only {
    padding-top: 24px;
    padding-bottom: 30px;

    @media (min-width: 768px) {
      padding-top: 0;
      padding-bottom: 0;
    }

    h3 {
      margin-bottom: 10px;
    }

    p {
      font-size: 16px;
      font-weight: 300;
    }

    .button-group {
      column-gap: 10px;

      @media (min-width: 768px) {
        column-gap: 0;
        row-gap: 20px;
      }
    }
  }
}

.subcategory-inner {

  .subcategory-item--text-only & {
    @media (min-width: 768px) {
      padding: 24px 20px 30px;
    }
  }
}
.subcategory-title {
  font-size: 20px;
  line-height: 26px;
  font-weight: 500;
  margin: 10px 0 5px;
}

.subcategory-desc {
  font-weight: 300;
}

.dropdown-item {
  padding: 16px 10px;
  border-bottom: 1px solid $border-color;
}

.footer {
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);
  background-color: white;
  transition: all .3s ease-in-out;
  position: fixed;
  z-index: 11111;
  bottom: 0;
  left: 0;
  width: 100%;
  transform: translateY(100%);
  padding: 20px;

  &__total {
    display: none !important;

    @media (min-width: 1150px) {
      display: flex !important;
    }
  }

  .price {
    font-weight: 900;
  }

  &.active {
    transform: translate(0px, 0px);

    .expand-toggle a {
      svg {
        transform: rotate(-90deg);
      }
    }
  }

  .product-list {
    overflow: auto;
    max-height: 15vh;

    @media (min-width: 1150px) {
      max-height: 80vh;
    }
  }

  .expand-toggle {
    display: flex;
    align-items: center;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;

    a {
      background-color: white;
      color: $basic-font-color;
      transform: translate(-100%, 0);
      box-shadow:  -7px 0px 6px rgba(0, 0, 0, 0.15);
      transition: all .3s ease-in-out;
      padding: 10px;
      border-right: 0px solid white;

      &:hover {
        border-right-width: 20px;
      }

      svg {
        transform-origin: 50%;
        transform: rotate(90deg);
        transition: all .3s ease-in-out;
      }
    }
  }

  &--articles {

    h3 {
      display: none;
    }

    @media (min-width: 1150px) {
        left: auto;
        width: 380px;
        right: 0;
        top: 0;
        transform: translate(360px, 0px);

        h3 {
          display: block;
          font-size: 20px;
          line-height: 26px;
          font-weight: 500;
        }
        .footer__articles {
          border-bottom: 1px solid $border-color;
          padding-bottom: 20px;
          margin-bottom: 10px;
          font-weight: 300;
          .price {
            font-weight: 300;
          }
        }
      }
  }
}

// @media (min-width: 768px) {
//   .articles {
//     border: 1px solid $border-color;
//   }
// }
</style>